import {
  HalfYearExtensionReason,
  YesOrNoFlug,
} from "../../../assets/data/Constants";
import { TypeTableBody } from "../../../type/componentsType/TkTable";
import {
  ChildcareLeaveInfoList,
  sixMonthsSalaryBeforeApplyList,
} from "../../../type/contextType/businessContext/IJob_32";
import { TkGetCode } from "../../../utils/TkGetCode";
import { changeAmountFormat } from "../../../utils/useTools";

function makeChildcareLeaveBodyList(
  list: ChildcareLeaveInfoList[]
): TypeTableBody[][] {
  const infoBodyList: TypeTableBody[][] = list?.map((item) => [
    {
      children: item.childcareLeaveSerialNo, // 育休連番
      align: "right",
    },
    {
      children: item.birthday, // 出生年月日
      align: "center",
    },
    {
      children: item.startDate, // 取得開始日
      align: "center",
    },
    {
      children: item.endDate, // 取得終了日
      align: "center",
    },
    {
      children: TkGetCode(YesOrNoFlug, item.papaMamaFlg), // パパ・ママ育休プラス有無
      align: "center",
    },
    {
      children: TkGetCode(
        HalfYearExtensionReason,
        item.halfyearExtensionReason
      ), // 育休半年延長の理由
    },
    {
      children: TkGetCode(YesOrNoFlug, item.papaChildcareLeaveFlg), // 産後パパ育休
      align: "center",
    },
  ]);

  return infoBodyList;
}

function makeSixMonthsSalaryBodyList(
  list: sixMonthsSalaryBeforeApplyList[]
): TypeTableBody[][] {
  const infoBodyList: TypeTableBody[][] = list?.map((item) => {
    let yearMonth = item.yearMonth?.toString();

    return [
      {
        children: yearMonth?.slice(0, 4) + "/" + yearMonth?.slice(4), // 年月
        align: "center",
      },
      {
        children: changeAmountFormat(item.salaryTableAmt ?? 0) + "円", // 俸給表の額
        align: "right",
      },
      {
        children: changeAmountFormat(item.salaryAdjustmentAmt ?? 0) + "円", // 俸給の調整額
        align: "right",
      },
    ];
  });

  return infoBodyList;
}

export { makeChildcareLeaveBodyList, makeSixMonthsSalaryBodyList };
